<div class="modal-header">
    <h3>{{ title }}</h3>
    <button mat-button (click)="onClose()" class="close-btn">Close</button>
</div>

<div class="modal-content">
    <!-- Chart Section-->
    <div class="charts-section">
        <div class="chart-card">
            <div class="title-with-legend">
                <p>Seasonal Lost Sales vs Overstock (trend)</p>
                <div class="legend">
                    <span>
                        <div class="legend-color" style="background-color: #007bff"></div>
                        Lost Sales
                    </span>
                    <span>
                        <div class="legend-color" style="background-color: #333"></div>
                        Overstock
                    </span>
                </div>
            </div>
            <p-chart type="bar" [data]="data.seasonalLostSalesData" [options]="data.seasonalLostSalesOptions"></p-chart>
        </div>
    </div>
</div>
